var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.picList),function(all,indext){return _c('ly-form-item',{key:indext,attrs:{"label":all.lable}},[_vm._v("\n\n        "+_vm._s(all.remark)+"\n        "),_c('imgList',{attrs:{"data":all.fileList}})],1)}),1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4ba1b438","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/diaodu/jincheng/filePathList.vue
// module id = null
// module chunks = 